import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


export default function Header() {
  // State to store the current theme
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Effect to apply the theme class to the body element
  useEffect(() => {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
    // localStorage.setItem('theme', theme); // Save the selected theme in localStorage
  }, [theme]);


  // Fullscreen toggle handler
  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };
  // Initialize 'togel' state from localStorage, default to light mode if not found
  const [togel, setTogel] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode ? JSON.parse(savedMode) : false; // Default to light mode (false)
  });

  // Effect to apply theme and save state to localStorage
  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', togel ? 'dark' : 'light');
    localStorage.setItem('darkMode', JSON.stringify(togel));
  }, [togel]);

  useEffect(() => {
    const fullscreenButton = document.querySelector('[data-toggle="fullscreen"]');
    if (fullscreenButton) {
      fullscreenButton.addEventListener('click', handleFullscreenToggle);
    }

    return () => {
      if (fullscreenButton) {
        fullscreenButton.removeEventListener('click', handleFullscreenToggle);
      }
    };
  }, []);

  return (
    <>
      <header id="page-topbar">
        <div className="layout-width ">
          <div className="navbar-header">
            <div className="d-flex">
              {/* LOGO */}
              <div className="navbar-brand-box horizontal-logo">
                <a href="index.html" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src="../assets/images/logo-sm.png" alt="" height={120} />
                  </span>
                  <span className="logo-lg">
                    <img src="../assets/images/logo-dark.png" alt="" height={120} />
                  </span>
                </a>
                <a href="index.html" className="logo logo-light">
                  <span className="logo-sm">
                    <img src="../assets/images/logo-sm.png" alt="" height={120} />
                  </span>
                  <span className="logo-lg">
                    <img src="../assets/images/logo-light.png" alt="" height={120} />
                  </span>
                </a>
              </div>
              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger d-md-none material-shadow-none"
                onClick={() => setSidebarOpen((prev) => !prev)}
              >
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>

            </div>

            <div className="d-flex align-items-center">
              {/* Fullscreen Button */}
              <div className="ms-1 header-item d-none d-sm-flex">
                <button
                  type="button"
                  className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                  data-toggle="fullscreen"
                >
                  <i className="bx bx-fullscreen fs-22" />
                </button>
              </div>

              {/* Light/Dark Mode Button */}
              <div className="ms-1 header-item d-none d-sm-flex">
                <button
                  type="button"
                  className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle light-dark-mode"
                  onClick={() => setTogel((prev) => !prev)}
                >
                  <i className={`bx ${theme === 'light' ? 'bx-moon' : 'bx-sun'} fs-22`} />
                </button>
              </div>

              {/* User Profile Dropdown */}
              <div className="dropdown ms-sm-3 header-item topbar-user">
                <button
                  type="button"
                  className="btn material-shadow-none"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src="../assets/images/users/avatar-1.jpg"
                      alt="Header Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        Hello Admin!
                      </span>

                    </span>
                  </span>
                </button>
                <div className="dropdown-menu dropdown-menu-end">

                  <h6 className="dropdown-header">Welcome Admin !</h6>

                  {/* <a className="dropdown-item" href="managepassword"><i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1" /> <span className="align-middle">Manage Password</span></a> */}
                  <a className="dropdown-item" href="authentication"><i className="mdi mdi-lock text-muted fs-16 align-middle me-1" /> <span className="align-middle">Lock screen</span></a>
                  <a className="dropdown-item" href="/"><i className="mdi mdi-logout text-muted fs-16 align-middle me-1" /> <span className="align-middle" data-key="t-logout">Logout</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>

        <div id="scrollbar" className="scroll-container">
          <div className="container-fluid">
            <ul className="navbar-nav" id="navbar-nav">
              {/* Dashboard Menu */}
              <li className="menu-title">
                <span>Menu</span>
              </li>
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/dashbord">
                  <i className="ri-dashboard-2-line" /> <span>Dashboards</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/memberreport">
                  <i class="bi bi-highlights" /> <span>Member Report</span>
                </Link>
              </li>

              {/* Reports Menu */}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarReports"
                  data-bs-toggle="collapse"
                  data-bs-auto-close="outside"
                >
                  <i className="ri-folder-line" /> <span>Reports</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarReports">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/stakingsidbarreport" className="nav-link">
                        Staking Report
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/levelrewardsidbar" className="nav-link">
                        Level Reward Report
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/poolsidebar" className="nav-link">
                        Pool Reward
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/weeklysidebar" className="nav-link">
                        Weekly Reward
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/roiofroi" className="nav-link">
                        Roi Roi
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/primesidebar" className="nav-link">
                        Prime Reward
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              {/* Pools Packages Menu */}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarPackages1122"
                  data-bs-toggle="collapse"
                  data-bs-auto-close="outside"
                >
                  <i className="ri-money-dollar-circle-line" /> <span>Pools Packages</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarPackages1122">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/one" className="nav-link">
                        Pool: 1
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/two" className="nav-link">
                        Pool: 2
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/three" className="nav-link">
                        Pool: 3
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/four" className="nav-link">
                        Pool: 4
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              {/* Packages Menu */}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarPackages"
                  data-bs-toggle="collapse"
                  data-bs-auto-close="outside"
                >
                  <i class="bi bi-backpack" /> <span>Packages</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarPackages">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/fifty" className="nav-link">
                        $50
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/hundred" className="nav-link">
                        $100
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/fivehundred" className="nav-link">
                        $500
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/thousand" className="nav-link">
                        $1000
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              {/* Pools Menu */}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarpool"
                  data-bs-toggle="collapse"
                  data-bs-auto-close="outside"
                >
                  <i className="ri-wallet-2-line" /> <span>Deposits</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarpool">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/pendingdeposits" className="nav-link">
                        Pending Deposits
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/deposits" className="nav-link">
                        Deposits
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link menu-link" to="/adminDeposit">
                  <i className="ri-apps-2-line" /> <span>Admin Deposit</span>
                </Link>
              </li> */}
              {/* Withdrawal Menu */}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarWithdrawal"
                  data-bs-toggle="collapse"
                  data-bs-auto-close="outside"
                >
                  <i className="ri-wallet-line" /> <span>Withdrawal</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarWithdrawal">
                  <ul className="nav nav-sm flex-column">
                    {/* <li className="nav-item">
                      <Link to="/pendingwithdrwalsidebar" className="nav-link">
                        Pending Withdrawal
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/withdrwalsidebar" className="nav-link">
                        Withdrawal
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              {/* Manual Operations Menu */}
              {/* <li className="nav-item">
                <Link className="nav-link menu-link" to="/manualop">
                  <i className="ri-apps-2-line" /> <span>Manual Operations</span>
                </Link>
              </li> */}

              <li className="nav-item">
                <Link className="nav-link menu-link" to="/pools">
                  <i class="bi bi-boxes" /> <span>Pools</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/userlistbyDate">
                  <i class="bi bi-people-fill" /> <span>User List</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/userBalance">
                  <i class="bi bi-cash-stack" /> <span>User Balance</span>
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link menu-link" to="/adminpurchase">
                  <i class="bi bi-clipboard2-data" /> <span>Admin Purchase</span>
                </Link>
              </li> */}
              {/* <li className="nav-item">
                <Link className="nav-link menu-link" to="/depositWithdrawal">
                  <i class="bi bi-cpu" /> <span>Admin Operation</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}


